import React from 'react';

import Button from '@components/button/Button';
import Icon from '@components/icon/Icon';
import { LeadImportOption } from '@features/lead-management/types/common';

interface LeadListEmptyViewProps {
  onCsvUpload?: () => void;
  onAddManually?: () => void;
}

const LeadListEmptyView = ({
  onCsvUpload,
  onAddManually
}: LeadListEmptyViewProps) => {
  const leadImportOptions: LeadImportOption[] = [
    {
      id: 'csv-upload',
      iconName: 'doc-upload',
      iconClassName: 'h-25.5 w-29',
      title: 'CSV/Excel Upload',
      description: 'Upload leads from spreadsheet files',
      buttonLabel: 'Start Import',
      onClick: onCsvUpload
    },
    {
      id: 'manual-add',
      iconName: 'manual-add',
      iconClassName: 'size-25.5',
      title: 'Add manually',
      description: 'Add individual leads manually',
      buttonLabel: 'Add Manually',
      onClick: onAddManually
    }
  ];

  return (
    <div className="flex flex-col items-center justify-center p-8">
      <div className="flex flex-col items-center gap-6 rounded-2xl bg-white p-8 shadow-lg">
        <div className="flex flex-col items-center gap-1">
          <div className="text-center text-2xl font-medium text-content">
            How would you like to import leads?
          </div>
          <div className="mt-1 text-center text-lg font-normal text-grey">
            Choose an import method to begin adding leads to your database
          </div>
        </div>

        <div className="flex items-center gap-6">
          {leadImportOptions.map((option) => (
            <div
              key={option.id}
              className="flex min-w-80 flex-1 flex-col items-center justify-center gap-6 rounded-xl border border-grey30 bg-white p-8"
            >
              <div
                className={`flex items-center justify-center ${option.iconClassName}`}
              >
                <Icon
                  name={option.iconName}
                  size="none"
                  className={option.iconClassName}
                />
              </div>
              <div className="flex flex-col items-center gap-3">
                <div className="text-center text-xl font-semibold text-content">
                  {option.title}
                </div>
                <div className="whitespace-nowrap text-center text-base font-normal text-grey">
                  {option.description}
                </div>
              </div>
              <Button
                variant="secondary"
                label={option.buttonLabel}
                handleClick={option.onClick}
                className="w-fit"
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default LeadListEmptyView;
